<template>
  <div>
    <div v-if="!process">
      <Loading />
    </div>
    <b-modal
      v-model="reset"
      id="modal-newpassword"
      ref="modal"
      size="sm"
      centered
      hide-footer
      hide-header   
      content-class="rounded-0"   
      no-stacking
      no-close-on-backdrop
      no-close-on-esc
    > 
      <form ref="form" @submit.stop.prevent="handleSubmit" v-if="process" class="font-k2d">
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-img src="../assets/img/logo-V2-2022.png" class="w-50"></b-img>
            <h4 class="mt-3">สร้างรหัสผ่านใหม่ {{code}}</h4>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center" v-if="code=='007'">
          <b-col class="text-center">
            <h5 class="my-3 text-danger">{{message}}</h5>
            <b-button variant="outline-primary" v-b-modal.modal-login @click="forgot=true" pill>ลืมรหัสผ่าน</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center" v-else>
          <b-col class="col-10">
            <b-form-group label="รหัสผ่านใหม่">
              <b-form-input type="password"
                            id="password"
                            v-model="password"
                            :state="passwordState"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="passwordState">
                <b-icon icon="x"></b-icon> กรุณากรอกรหัสผ่าน อย่างน้อย 8 หลัก
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="passwordState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
            
          <b-col class="col-10">
            <b-form-group label="รหัสผ่านใหม่ อีกครั้ง">
              <b-form-input type="password"
                            id="password2"
                            v-model="password2"
                            :state="password2State"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="password2State">
                <b-icon icon="x"></b-icon> รหัสผ่านไม่ตรงกัน
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="password2State">
                <b-icon icon="check"></b-icon> รหัสผ่านตรงกัน
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
          <b-col class="col-12 text-center">
            <b-button class="mt-3 mb-3" type="submit" variant="outline-primary" :disabled="!completeState" pill>ยืนยัน</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>

    <!-- forgot -->
    <b-modal  
      v-model="forgot"
      id="modal-forgot"
      ref="modal"
      centered
      hide-footer
      hide-header
      content-class="rounded-0"
      no-stacking
      no-close-on-backdrop
      no-close-on-esc
      size="sm"
    > 
      <form ref="form" @submit.stop.prevent="handleForgot">
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-img src="../assets/img/logo-V2-2022.png" class="w-50"></b-img>
            <h4 class="mt-3">ลืมรหัสผ่านของคุณใช่หรือไม่</h4>
            <h6 class="mt-1">ป้อนอีเมลของคุณและเราจะส่งคำแนะนำในการรีเซ็ตรหัสผ่านของคุณ</h6>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-col class="col-11">
            <b-form-group class="text-center">
              <b-form-radio-group
                v-model="animal"
                :options="animals"
                name="animal-group"
              ></b-form-radio-group>
            </b-form-group>
            <b-form-group>
              <b-form-input 
                type="email"
                v-model="email_forgot"
                placeholder="อีเมล"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col class="text-center">
            <b-button type="submit" variant="outline-success" :disabled="email_forgot==''" pill>ดำเนินการต่อ</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'FirstpageNewpassword',

  data() {
    return {
      process: true,
      reset: false,
      forgot: false,
      animal: '',
      animals: [
        {value: "", text: 'สัตว์บก'},
        {value: "/poultry", text: 'สัตว์ปีก'},
        // {value: 3, text: 'สัตว์น้ำ'}
      ],
      username: '',
      token: '',
      password: '',
      password2: '',
      email_forgot: '',
      code: '',
      message: ''
    };
  },

  mounted() {
    this.reset = false
    this.forgot = false
    // console.log(this.$route.query.animal)
    // console.log(this.$route.query.username)
    // console.log(this.$route.query.token)
    
    if(this.$route.query.animal != undefined && this.$route.query.username != undefined && this.$route.query.token != undefined && this.$route.query.animal != '' && this.$route.query.username != '' && this.$route.query.token != '') {
      this.animal = this.$route.query.animal != "poultry" ? "" : "poultry"
      this.username = this.$route.query.username
      this.token = this.$route.query.token

      this.$store.dispatch('checkForgot', {
        animal: this.animal,
        username: this.username,
        token: this.token
      })
      .then(response => {
        if(response.data.success == 1) {
          this.process = true
          this.reset = true
        }
        else{
          this.process = true
          this.forgot = true
          this.alertResult(`ไม่สำเร็จ!`, response.data.message, `danger`)
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
    else {
      this.$router.push({ name: "Login" });
    }
  },

  computed: {
    passwordState() {
      return this.password.length >= 8 && this.password.length <= 15
    },
    password2State() {
      return this.password == this.password2 && this.password2 != ''
    },
    completeState() {
      return this.passwordState && this.password2State
    },
  },

  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.process = false
      this.message = ''
      this.code = ''
      this.$store.dispatch('newPassword', {
        animal: this.animal,
        username: this.username,
        password: this.password,
        token: this.token
      })
      .then(response => {
        if(response.data.success == 1) {
          this.process = true
          this.alertResult(`สร้างรหัสผ่านใหม่ สำเร็จ!`, response.data.message, `success`)
          setTimeout(() => {
            this.$router.push({ name: "Login" });
          }, 2000)
        }
        else{
          this.process = true
          if(response.data.code == "007") {
            this.forgot = true
            this.code = response.data.code
            this.message = response.data.message
          }
          else {
            this.alertResult(`สร้างรหัสผ่านใหม่ ไม่สำเร็จ!`, response.data.message, `danger`)
          }
        }
      })
      .catch(error => {
        console.log(error)
      })
    },
    handleForgot(e) {
      e.preventDefault();
      this.process = true
      this.$store.dispatch("Forgot", {
        animal: this.animal,
        username: this.email_forgot
      })
      .then((response) => {
        if(response.data.success == 1) {
          setTimeout(() => {
            this.process = false
            this.alertResult(`สำเร็จ`, `กรุณาตรวจสอบอีเมลของคุณ!`, `success`);
          }, 2000)
        } 
        else {
          this.loginFaild(response.data.message)
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    alertResult(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        autoHideDelay: 5000,
        appendToast: false,
        variant: variant,
        toaster: "b-toaster-bottom-right",
        solid: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>